import { camelCaseResponse } from "../shared/Functions";
import { emptyApi } from "./emptyApi";

export interface AiUploadDataRequest {
  org_player_ids: string[];
  movement_type_id: number;
  session_ids: string[];
  /**
   * Additional export data types to upload alongside the standard metrics export
   * (e.g. ["inverse-kinematics"]). Omit for the default metrics-only export.
   */
  data_types?: string[];
}

export interface AiUploadDataFileInfo {
  id: string;
  filename: string;
  mimeType: string;
  sizeBytes: number;
}

export interface AiUploadDataResponse {
  containerId: string;
  fileIds?: string[];
  filesList?: AiUploadDataFileInfo[];
  dataSummary?: string;
  failedUploads?: any[];
  failedSessions?: any[];
  succeededSessions?: string[];
}

export interface ChatMessageContentText {
  type: "text";
  text: string;
}

export interface ChatMessageContentDocument {
  type: "document";
  source: {
    type: "file";
    file_id: string;
  };
  title?: string;
  context?: string;
  citations?: {
    enabled: string;
  };
}

export interface ChatMessageContentContainerUpload {
  type: "container_upload";
  file_id: string;
}

export type ChatMessageContent =
  | ChatMessageContentText
  | ChatMessageContentDocument
  | ChatMessageContentContainerUpload;

export interface ChatMessage {
  role: "user" | "assistant";
  content: ChatMessageContent[];
}

export interface AiChatRequest {
  session_id: string;
  messages: ChatMessage[];
  container_id?: string;
  temperature?: number;
  max_tokens?: number;
  save_chat?: boolean;
  analytics_metadata?: Record<string, any>;
  custom_context?: string;
  model?: string;
}

export const aiChatExtendedApi = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadAiData: builder.mutation<AiUploadDataResponse, AiUploadDataRequest>({
      query: (data) => ({
        url: "/ai/upload_data",
        method: "POST",
        body: data,
      }),
      transformResponse: (response: any) => camelCaseResponse(response),
    }),
  }),
});

export const { useUploadAiDataMutation } = aiChatExtendedApi;
